'use client';

import dynamic from 'next/dynamic';

const StrokeStylesDemo = dynamic(() => import('./StrokeStylesDemo'));

export default StrokeStylesDemo;
